export class cAdminUsers {
  a_linkbutton = document.createElement('a');
  button       =  document.querySelector('.tablenav.top div:has(#bulk-action-selector-top)') as HTMLElement;

  constructor() {
    if (this.button === null) return

    this.button.insertAdjacentElement('afterend', this.a_linkbutton);

    this.a_linkbutton.classList.add('page-title-action')
    this.a_linkbutton.innerText    = 'Benutzerliste herunterladen';
    this.a_linkbutton.href         = '/c-users';
    this.a_linkbutton.style.margin = '3px 0 0 -10px';
  }

}